import { EventBus, Events } from '../../managers';

interface ToastOptions {
  type: 'success' | 'error' | 'info' | 'social';
  message: string;
  duration?: number;
  avatarUrl?: string;
}

class ToastManagerClass {
  private container: HTMLElement | null = null;

  initialize(): void {
    // Create toast container if it doesn't exist
    this.container = document.getElementById('toast-container');
    if (!this.container) {
      this.container = document.createElement('div');
      this.container.id = 'toast-container';
      document.body.appendChild(this.container);
    }

    // Listen for toast events
    EventBus.on(Events.SHOW_TOAST, (options: unknown) => {
      this.show(options as ToastOptions);
    });
  }

  show(options: ToastOptions): void {
    const { type, message, duration = 3000, avatarUrl } = options;

    const toast = document.createElement('div');
    toast.className = `toast toast-${type}`;

    if (avatarUrl) {
      const img = document.createElement('img');
      img.className = 'toast-avatar';
      img.src = avatarUrl;
      img.alt = '';
      toast.appendChild(img);
    }

    const text = document.createElement('span');
    text.textContent = message;
    toast.appendChild(text);

    this.container?.appendChild(toast);

    // Trigger animation
    requestAnimationFrame(() => {
      toast.classList.add('show');
    });

    // Auto-remove
    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => {
        toast.remove();
      }, 300);
    }, duration);
  }
}

export const ToastManager = new ToastManagerClass();
